import moment from 'moment-timezone';

/*
 *
 * @param {Object} value , returns value which is human readable.
 * Example:
 * 1 1
 * 10 10
 * 100 100
 * 1000 1 k
 * 10000 10 k
 * 100000 100 k
 * 1000000 1 M
 * 10000000 10 M
 * 100000000 100 M
 * @param {Number} value Original value.
 * @return {String} humanized representation.
 */

function humanize(value, unit) {
  let prefix;

  if (typeof value !== 'number') {
    return null;
  }

  // commented out as fps should also be humanized
  // dimension table calls humanize without a unit and fps gets rounded off
  // in case of pulse4 fps is getting humanized from backend
  // if (unit && unit.indexOf('fps') > -1) return value.toString();

  const num = value.toExponential(2).split('e');
  const mant = Math.round(Number(num[0]) * 100);
  const exp = Number(num[1]);

  let res = (mant * 10 ** (exp % 3)) / 100;

  if (unit === 'ms') {
    const replaceableUnit = ['ms', 'secs', 'mins'];
    res += ` ${replaceableUnit[Math.floor(exp / 3)]}`;
    return res;
  }

  if (unit === 'bps') {
    prefix = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
  } else {
    prefix = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
  }

  if (exp >= -3 && exp < 0) {
    res = Math.round(Number(value) * 1000) / 1000;
  } else if (exp >= 0 && exp < 3) {
    res += '';
  } else if (exp > 0 && exp < 24) {
    res += ` ${prefix[Math.floor(exp / 3)]}`;
  } else {
    res = Number(value).toExponential(1);
  }

  return res;
}

export const formatEndedStatus = (data) => {
  let result = '';
  switch (data) {
    case 'eGracefulEnd':
      result = 'Graceful End';
      break;
    case 'eByExpiration':
      result = 'By Expiration';
      break;
    case 'eNotEnded':
      result = 'Not Ended';
      break;
    default:
      result = '';
      break;
  }
  return result;
};

export const getTimeDifferenceDescription = (comparedTime: moment.Moment) => {
  const now = moment();
  const duration = moment.duration(now.diff(comparedTime));

  let output = '';

  if (duration.asYears() >= 1) {
    output = `${Math.floor(duration.asYears())}y`;
  } else if (duration.asMonths() >= 1) {
    output = `${Math.floor(duration.asMonths())}M`;
  } else if (duration.asWeeks() >= 1) {
    output = `${Math.floor(duration.asWeeks())}w`;
  } else if (duration.asDays() >= 1) {
    output = `${Math.floor(duration.asDays())}d`;
  } else if (duration.asHours() >= 1) {
    output = `${Math.floor(duration.asHours())}h`;
  } else if (duration.asMinutes() >= 1) {
    output = `${Math.floor(duration.asMinutes())}m`;
  } else {
    output = `${Math.floor(duration.asSeconds())}s`;
  }

  if (output !== '') {
    return `${output} ago`;
  }

  return 'just now';
};

export default humanize;
